/*
  Custom (bauaet.ae): add-to-cart for redesigned sections, bundle add, deal countdown.
  After adding, fires Expanse's `ajaxProduct:added` event so its cart drawer refreshes and opens.
*/
(function () {
  var strings = window.bauaetStrings || {};
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function toast(message) {
    var el = document.createElement('div');
    el.className = 'b-toast';
    el.setAttribute('role', 'status');
    el.textContent = message;
    document.body.appendChild(el);
    setTimeout(function () { el.remove(); }, 3000);
  }

  function addItems(form) {
    var button = form.querySelector('[type="submit"]');
    var items;

    if (form.dataset.items) {
      items = JSON.parse(form.dataset.items);
    } else {
      items = [{ id: Number(form.querySelector('[name="id"]').value), quantity: Number((form.querySelector('[name="quantity"]') || {}).value || 1) }];
    }
    if (!items.length) return;

    var label = button.textContent;
    button.classList.add('is-loading');
    button.textContent = strings.adding || label;

    var discount = form.dataset.discount;
    var applyDiscount = discount
      ? fetch(root + 'discount/' + encodeURIComponent(discount), { credentials: 'same-origin' }).catch(function () {})
      : Promise.resolve();

    applyDiscount
      .then(function () {
        return fetch(root + 'cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        });
      })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw data;
          return data;
        });
      })
      .then(function (data) {
        button.textContent = strings.added || label;
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { product: data, addToCartBtn: button }
        }));
      })
      .catch(function (error) {
        toast((error && error.description) || strings.add_error || 'Error');
      })
      .then(function () {
        setTimeout(function () {
          button.classList.remove('is-loading');
          button.textContent = label;
        }, 1200);
      });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest && event.target.closest('form[data-bauaet-add]');
    if (!form || !window.fetch) return;
    event.preventDefault();
    addItems(form);
  });

  // Countdown: data-countdown="2026-10-31 23:59" is read as UAE time (UTC+4)
  function startCountdown(el) {
    var match = (el.dataset.countdown || '').trim().match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2}))?$/);
    if (!match) return;
    var hour = match[4] ? Number(match[4]) : 23;
    var minute = match[5] ? Number(match[5]) : 59;
    var end = Date.UTC(Number(match[1]), Number(match[2]) - 1, Number(match[3]), hour - 4, minute);

    var units = {};
    el.querySelectorAll('[data-unit]').forEach(function (u) { units[u.dataset.unit] = u; });

    function tick() {
      var left = Math.max(0, end - Date.now());
      if (left <= 0) {
        el.hidden = true;
        clearInterval(timer);
        return;
      }
      var s = Math.floor(left / 1000);
      units.d.textContent = Math.floor(s / 86400);
      units.h.textContent = Math.floor((s % 86400) / 3600);
      units.m.textContent = Math.floor((s % 3600) / 60);
      units.s.textContent = s % 60;
      el.hidden = false;
    }

    var timer = setInterval(tick, 1000);
    tick();
  }

  // Explore page: filter collection cards by name as the customer types
  function initFilter(root) {
    var input = root.querySelector('[data-b-filter]');
    if (!input || input.dataset.bound) return;
    input.dataset.bound = 'true';
    var empty = root.querySelector('[data-b-empty]');

    input.addEventListener('input', function () {
      var term = input.value.trim().toLowerCase();
      var anyVisible = false;
      root.querySelectorAll('[data-b-group]').forEach(function (group) {
        var groupVisible = false;
        group.querySelectorAll('[data-b-name]').forEach(function (card) {
          var match = !term || card.dataset.bName.indexOf(term) !== -1;
          card.hidden = !match;
          if (match) groupVisible = true;
        });
        group.hidden = !groupVisible;
        if (groupVisible) anyVisible = true;
      });
      if (empty) empty.hidden = anyVisible;
    });
  }

  // Product page: WhatsApp link includes the currently selected variant
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('[data-b-whatsapp]');
    if (!link) return;
    var form = document.getElementById(link.dataset.form);
    var variantInput = form && form.querySelector('[name="id"]');
    var url = link.dataset.url + (variantInput ? '?variant=' + variantInput.value : '');
    var chosen = [];
    if (form) {
      document.querySelectorAll('[form="' + form.id + '"][data-variant-input]:checked, select[form="' + form.id + '"][data-variant-input]').forEach(function (el) {
        if (el.value) chosen.push(el.value);
      });
    }
    var text = link.dataset.message + (chosen.length ? ' (' + chosen.join(' / ') + ')' : '') + ' - ' + url;
    link.href = 'https://wa.me/' + link.dataset.number + '?text=' + encodeURIComponent(text);
  });

  // Product page: sticky add-to-cart bar
  function initStickyCart(bar) {
    if (bar.dataset.bound) return;
    bar.dataset.bound = 'true';
    var form = document.getElementById(bar.dataset.form);
    if (!form) return;
    var mainButton = form.querySelector('[data-add-to-cart]');
    var stickyButton = bar.querySelector('[data-b-sticky-add]');
    var stickyPrice = bar.querySelector('[data-b-sticky-price]');
    var section = form.closest('.product-section');
    var mainPrice = section && section.querySelector('[data-product-price]');
    if (!mainButton) return;

    function sync() {
      stickyButton.disabled = mainButton.disabled;
      var label = mainButton.querySelector('[data-add-to-cart-text]');
      if (label) stickyButton.textContent = label.textContent.trim();
      // Expanse prints each price twice (visible + screen-reader copy): use the visible one
      var shownPrice = mainPrice && (mainPrice.querySelector('[aria-hidden="true"]') || mainPrice);
      if (shownPrice && stickyPrice) stickyPrice.textContent = shownPrice.textContent.trim();
    }

    stickyButton.addEventListener('click', function () {
      mainButton.click();
    });

    new MutationObserver(sync).observe(form, { subtree: true, childList: true, characterData: true, attributes: true });
    if (mainPrice) new MutationObserver(sync).observe(mainPrice, { subtree: true, childList: true, characterData: true });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var hidden = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', hidden);
        bar.setAttribute('aria-hidden', hidden ? 'false' : 'true');
        stickyButton.tabIndex = hidden ? 0 : -1;
      }).observe(mainButton);
    }
    sync();
  }

  // Cart drawer + cart page: keep the item count and free-delivery bar in sync.
  // Expanse rebuilds [data-products] after every change; the new .cart__items carries
  // data-count and data-cart-subtotal (templates/cart.ajax.liquid).
  var countStrings = window.bauaetCartCount || {};

  // Arabic plural rules (CLDR); English only uses one/other, which these also cover.
  function pluralCount(n) {
    var s = countStrings;
    var mod = n % 100;
    if (n === 0 && s.zero) return s.zero;
    if (n === 1) return s.one;
    if (n === 2 && s.two) return s.two;
    if (mod >= 3 && mod <= 10 && s.few) return s.few.replace('3', n);
    if (mod >= 11 && mod <= 99 && s.many) return s.many.replace('11', n);
    return (s.other || '').replace('100', n);
  }

  function formatMoney(cents) {
    if (window.theme && theme.Currency && theme.settings) return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    return (cents / 100).toFixed(2);
  }

  function updateCartExtras(form) {
    var items = form.querySelector('.cart__items');
    if (!items) return;
    var count = parseInt(items.dataset.count, 10) || 0;
    var subtotal = parseInt(items.dataset.cartSubtotal, 10) || 0;

    var countEl = form.querySelector('[data-b-cart-count]') || document.querySelector('.b-cart-page [data-b-cart-count]');
    if (countEl) countEl.textContent = pluralCount(count);

    var ship = form.querySelector('[data-b-ship]');
    if (ship) {
      var threshold = parseInt(ship.dataset.threshold, 10);
      var remaining = threshold - subtotal;
      var percent = Math.min(100, Math.round((subtotal / threshold) * 100));
      ship.classList.toggle('is-done', remaining <= 0);
      ship.querySelector('[data-b-ship-text]').textContent = remaining > 0
        ? ship.dataset.textRemaining.replace('[amount]', formatMoney(remaining))
        : ship.dataset.textDone;
      ship.querySelector('[data-b-ship-fill]').style.width = percent + '%';
    }
  }

  function initCartForm(form) {
    if (form.dataset.bCart) return;
    form.dataset.bCart = 'true';
    var products = form.querySelector('[data-products]');
    if (!products) return;
    new MutationObserver(function () { updateCartExtras(form); }).observe(products, { childList: true });
    updateCartExtras(form);
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest && event.target.closest('[data-b-close-cart]')) {
      document.dispatchEvent(new CustomEvent('cart:close'));
    }
  });

  // Collection pages: "load more" appends the next page of products to the grid.
  // The numbered pagination is hidden while this works (it stays as a no-JS fallback).
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-b-load-more]');
    if (!button || button.classList.contains('is-loading')) return;
    var box = button.closest('[data-b-loadmore]');
    var grid = document.querySelector('.collection-grid');
    if (!grid || !button.dataset.next) return;

    var label = button.textContent;
    button.classList.add('is-loading');
    button.textContent = '…';

    fetch(button.dataset.next, { credentials: 'same-origin' })
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('.collection-grid');
        if (newGrid) {
          Array.prototype.slice.call(newGrid.children).forEach(function (child) {
            if (!child.classList.contains('grid-product')) return; // skip quick-view modals
            var quick = child.querySelector('.quick-product__btn');
            if (quick) quick.remove(); // quick view needs Expanse's modal init; the add button still works
            grid.appendChild(child);
          });
        }
        var nextButton = doc.querySelector('[data-b-load-more]');
        var shown = grid.querySelectorAll('.grid-product').length;
        var total = parseInt(box.dataset.total, 10) || shown;
        var status = box.querySelector('[data-b-loadmore-status]');
        if (status) status.textContent = status.dataset.template.replace('[shown]', shown).replace('[total]', total);
        var fill = box.querySelector('[data-b-loadmore-fill]');
        if (fill) fill.style.width = Math.min(100, Math.round((shown / total) * 100)) + '%';
        if (nextButton && nextButton.dataset.next) {
          button.dataset.next = nextButton.dataset.next;
        } else {
          button.remove();
        }
        if (window.lazySizes && lazySizes.autoSizer) lazySizes.autoSizer.checkElems();
      })
      .catch(function () {
        window.location.href = button.dataset.next;
      })
      .then(function () {
        button.classList.remove('is-loading');
        button.textContent = label;
      });
  });

  // In-page links (e.g. hero → bundles): if the target section is hidden/absent, go to the fallback page
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[data-b-anchor-fallback]');
    if (!link) return;
    var target = document.getElementById(link.getAttribute('href').replace('#', ''));
    if (!target || target.hidden || target.offsetParent === null) {
      event.preventDefault();
      window.location.href = link.dataset.bAnchorFallback;
    }
  });

  // Homepage "New arrivals": fetch the newest in-stock cards (see sections/bauaet-new-arrivals.liquid)
  function initNewest(grid) {
    if (grid.dataset.bound) return;
    grid.dataset.bound = 'true';
    var limit = parseInt(grid.dataset.limit, 10) || 8;
    fetch(grid.dataset.url, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var cards = Array.prototype.slice.call(doc.querySelectorAll('[data-b-newest-cards] > .b-card'), 0, limit);
        if (!cards.length) throw new Error('empty');
        grid.innerHTML = '';
        cards.forEach(function (card) { grid.appendChild(card); });
      })
      .catch(function () {
        var section = grid.closest('.b-section');
        if (section) section.hidden = true;
      });
  }

  function initLoadMore(box) {
    var pagination = box.parentElement && box.parentElement.querySelector('.pagination');
    if (pagination) pagination.hidden = true;
  }

  // Custom (bauaet.ae): category carousel — arrows, edge fades and progress bar.
  // RTL-aware: in Arabic scrollLeft runs from 0 to a negative number.
  function initCarousel(el) {
    if (el.dataset.bCarouselReady) return;
    el.dataset.bCarouselReady = '1';
    var track = el.querySelector('[data-b-carousel-track]');
    var nav = el.querySelector('[data-b-carousel-nav]');
    var prev = el.querySelector('[data-b-carousel-prev]');
    var next = el.querySelector('[data-b-carousel-next]');
    var progress = el.querySelector('[data-b-carousel-progress]');
    var bar = el.querySelector('[data-b-carousel-bar]');
    if (!track) return;
    var rtl = getComputedStyle(track).direction === 'rtl';

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      var pos = Math.abs(track.scrollLeft);
      var scrollable = max > 4;
      if (nav) nav.hidden = !scrollable;
      if (progress) progress.hidden = !scrollable;
      el.classList.toggle('can-prev', scrollable && pos > 4);
      el.classList.toggle('can-next', scrollable && pos < max - 4);
      if (prev) prev.disabled = !el.classList.contains('can-prev');
      if (next) next.disabled = !el.classList.contains('can-next');
      if (bar && scrollable) {
        var size = track.clientWidth / track.scrollWidth;
        var shift = (pos / max) * (1 - size) / size * 100;
        bar.style.setProperty('--b-progress-size', (size * 100) + '%');
        bar.style.setProperty('--b-progress-shift', (rtl ? -shift : shift) + '%');
      }
    }

    function go(direction) {
      var amount = Math.max(track.clientWidth * 0.8, 200) * direction;
      track.scrollBy({ left: rtl ? -amount : amount, behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    track.querySelectorAll('img').forEach(function (img) { img.addEventListener('load', update); });
    update();
  }

  // Custom (bauaet.ae): footer — menus start closed on phones (accordions), always open on
  // desktop; "back to top" button.
  function initFooter(footer) {
    if (footer.dataset.bFooterReady) return;
    footer.dataset.bFooterReady = '1';
    var phone = window.matchMedia('(max-width: 768px)');
    var accs = footer.querySelectorAll('[data-b-footer-acc]');
    function setOpen() {
      accs.forEach(function (acc) { acc.open = !phone.matches; });
    }
    setOpen();
    if (phone.addEventListener) phone.addEventListener('change', setOpen);
    var top = footer.querySelector('[data-b-to-top]');
    if (top) top.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }

  // Custom (bauaet.ae): category tiles crossfade through product photos of their collection.
  // Extra photos only carry data-b-src(set) and are loaded just before they are shown. Tiles are
  // staggered, and rotation pauses off-screen, in a hidden tab and for reduced-motion users.
  function initRotators(carousel) {
    if (carousel.dataset.bRotateReady) return;
    carousel.dataset.bRotateReady = '1';
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var tiles = Array.prototype.slice.call(carousel.querySelectorAll('[data-b-rotate]'));
    if (!tiles.length) return;
    var speed = Math.max(2, Number(carousel.dataset.bRotateSpeed) || 4) * 1000;
    var visible = false;
    var tick = 0;

    function load(img) {
      if (!img || !img.dataset || !img.dataset.bSrc) return;
      if (img.dataset.bSrcset) img.srcset = img.dataset.bSrcset;
      img.src = img.dataset.bSrc;
      delete img.dataset.bSrc;
      delete img.dataset.bSrcset;
    }

    function advance(tile) {
      // Slides = the photos plus, when present, the line-art drawing shown first
      var imgs = tile.querySelectorAll(':scope > img, :scope > .b-cat__art');
      var current = tile.querySelector(':scope > .is-active') || imgs[0];
      var index = Array.prototype.indexOf.call(imgs, current);
      var next = imgs[(index + 1) % imgs.length];
      load(next);
      load(imgs[(index + 2) % imgs.length]); // warm up the one after
      function show() {
        current.classList.remove('is-active');
        next.classList.add('is-active');
      }
      if (next.tagName !== 'IMG' || (next.complete && next.naturalWidth)) show();
      else next.addEventListener('load', show, { once: true });
    }

    // Every tick advances one group of tiles, so they change at different moments
    var groups = 3;
    setInterval(function () {
      if (!visible || document.hidden) return;
      tiles.forEach(function (tile, i) {
        if (i % groups === tick % groups) advance(tile);
      });
      tick++;
    }, speed / groups);

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
      }, { rootMargin: '100px' }).observe(carousel);
    } else {
      visible = true;
    }
  }

  function init() {
    document.querySelectorAll('[data-b-newest]').forEach(initNewest);
    document.querySelectorAll('[data-b-loadmore]').forEach(initLoadMore);
    document.querySelectorAll('.cart__drawer-form, #CartPageForm').forEach(initCartForm);
    document.querySelectorAll('[data-countdown]').forEach(startCountdown);
    document.querySelectorAll('[data-b-explore]').forEach(initFilter);
    document.querySelectorAll('[data-b-sticky-cart]').forEach(initStickyCart);
    document.querySelectorAll('[data-b-carousel]').forEach(initCarousel);
    document.querySelectorAll('[data-b-rotate-speed]').forEach(initRotators);
    document.querySelectorAll('[data-b-footer]').forEach(initFooter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init when sections are edited in the theme editor
  document.addEventListener('shopify:section:load', init);
})();
